import { createToken } from '@react-apps/core';
import type { CatalogRepositoryImpl } from '../data/repositories/catalog.repository.impl';

export const CatalogRepositoryToken =
  createToken<CatalogRepositoryImpl>('CatalogRepository');
